import { useCallback, useLayoutEffect, useRef } from "react";
function useIsUnmounted() {
  const rIsUnmounted = useRef("mounting");
  useLayoutEffect(() => {
    rIsUnmounted.current = "mounted";
    return () => void (rIsUnmounted.current = "unmounted");
  }, []);
  return useCallback(() => rIsUnmounted.current !== "mounted", []);
}
export {
  useIsUnmounted
};
//# sourceMappingURL=useIsUnmounted.js.map
